/*
 * Copyright (c) 2024 NOOGA DEVELOPMENT, All rights reserved.
 * Author Julia Romanovskaya <julia.romanovskaya@noogadev.com>
 */

import { createAction } from 'utils/redux-utils';
import { Notification } from '../../../../utils/utils';
import { AiClassificationsHistoryDto, PageQueryParams } from '../../../api/apiCommon.typings';

export enum CashBoxAiClassificationTabActionType {
    EXIT_CASHBOX_AI_CLASSIFICATIONS_TAB = 'CashBoxAiClassificationTab/ exit tab',
    FETCH_AI_CLASSIFICATIONS_HISTORY = 'CashBoxAiClassificationTab/ fetch ai classifications history start',
    FETCH_AI_CLASSIFICATIONS_HISTORY_SUCCESS = 'CashBoxAiClassificationTab/ fetch ai classifications history success',
    FETCH_AI_CLASSIFICATIONS_HISTORY_ERROR = 'CashBoxAiClassificationTab/ fetch ai classifications history error',
    DOWNLOAD_AI_CLASSIFICATIONS_HISTORY = 'CashBoxAiClassificationTab/ download ai classifications history start',
    DOWNLOAD_AI_CLASSIFICATIONS_HISTORY_SUCCESS = 'CashBoxAiClassificationTab/ download ai classifications history success',
    DOWNLOAD_AI_CLASSIFICATIONS_HISTORY_ERROR = 'CashBoxAiClassificationTab/ download ai classifications history error',
}

export const exitCashBoxAiClassificationTabAction = () =>
    createAction(CashBoxAiClassificationTabActionType.EXIT_CASHBOX_AI_CLASSIFICATIONS_TAB);

export const fetchCashboxClassificationsHistoryAction = (params: PageQueryParams) =>
    createAction(CashBoxAiClassificationTabActionType.FETCH_AI_CLASSIFICATIONS_HISTORY, params);

export const fetchCashboxClassificationsHistorySuccessAction = (payload: AiClassificationsHistoryDto) =>
    createAction(CashBoxAiClassificationTabActionType.FETCH_AI_CLASSIFICATIONS_HISTORY_SUCCESS, payload);

export const fetchCashboxClassificationsHistoryErrorAction = (notification: Notification) =>
    createAction(CashBoxAiClassificationTabActionType.FETCH_AI_CLASSIFICATIONS_HISTORY_ERROR, { notification });

export const downloadCashboxClassificationsHistoryAction = () =>
    createAction(CashBoxAiClassificationTabActionType.DOWNLOAD_AI_CLASSIFICATIONS_HISTORY);

export const downloadCashboxClassificationsHistorySuccessAction = () =>
    createAction(CashBoxAiClassificationTabActionType.DOWNLOAD_AI_CLASSIFICATIONS_HISTORY_SUCCESS);

export const downloadCashboxClassificationsHistoryErrorAction = (notification: Notification) =>
    createAction(CashBoxAiClassificationTabActionType.DOWNLOAD_AI_CLASSIFICATIONS_HISTORY_ERROR, { notification });

export type CashBoxAiClassificationTabAction =
    | ReturnType<typeof exitCashBoxAiClassificationTabAction>
    | ReturnType<typeof fetchCashboxClassificationsHistoryAction>
    | ReturnType<typeof fetchCashboxClassificationsHistorySuccessAction>
    | ReturnType<typeof fetchCashboxClassificationsHistoryErrorAction>
    | ReturnType<typeof downloadCashboxClassificationsHistoryAction>
    | ReturnType<typeof downloadCashboxClassificationsHistorySuccessAction>
    | ReturnType<typeof downloadCashboxClassificationsHistoryErrorAction>;
